import { Combobox } from '@src/components'
import { REGISTER_COLUMNS } from '@src/constants'
import { RegisterColumn } from './RegisterColumn'

export class LabDiagnosticsList extends RegisterColumn {
  static type = REGISTER_COLUMNS.LAB_DIAGNOSTICS_LIST

  constructor (store, settings) {
    const column = {
      header: {
        title: 'Лабораторные исследования',
        component: Combobox,
        props: {
          allowClear: true,
          options: [
            {
              label: 'Есть',
              value: true,
            },
            {
              label: 'Нет',
              value: false,
            },
          ],
        },
      },
      width: 200,
      dataIndex: 'has_lab_diagnostics',
      dataRender: has_lab_diagnostics => typeof has_lab_diagnostics === 'boolean' ? has_lab_diagnostics ? 'Есть' : 'Нет' : '-',
      sort: true,
    }

    super(column, settings)
  }

  _requestArgs ({ filters }) {
    return {
      control: {
        filters: typeof filters.has_lab_diagnostics === 'boolean'
          ? [{
            field: 'has_lab_diagnostics',
            value: String(filters.has_lab_diagnostics),
            operator: '=',
            invalid: false,
            fieldtype: 'TS',
          }]
          : [],
      },
    }
  }
}
